<template>
	<div class="entranceindex songlist-row-s" v-finger:swipe="swipeHandler" :style="{height: scrollerHeight}">
		<router-view :tabListActive="tabListActive" @tablist="tablistFun"/>
<!--		<my-footer  v-if="tabbarActive>-1" :pathlist="pathlist"></my-footer>-->
		<!--<my-footer v-if="tabbarActive>-1" :active="tabbarActive" :pathlist="pathlist"></my-footer>-->
	</div>
</template>

<script>
import { mapActions } from "vuex";
// import myFooter from '../components/myFooter.vue'
// import home from '@api/home';
export default {
	name: 'Home',
	components: {
		// myFooter
	},
	data() {
		return {
            tabbarActive: -1, //默认footer菜单第一个
            tabListActive: 0, //默认列表菜单第一个
            forbidFinger: 0, //警用手势状态值
            tablist: [], //获取列表菜单数组
            pathlist: ['/home','/monitor','/project','/application','/my'], //需要切换的footer菜单的页面路径
            tabPageList: ['/project/qtindex','/project/checkList', '/project/logList', '/project/qualityAcceptanceList','/project/qualityAcceptanceList'], //需要切换的列表菜单的页面路径
            forbidFingerList: ['/bimView', '/bimWithPin', '/bimViewDetail', '/componentSearch','/project/clindex', '/project/imgscll','/project/leaders/addrecordDetails','/project/projectManagerRecord'], //禁用手势组件的页面
            scrollerHeight:'100%',
        }
	},
	methods: {
        ...mapActions(["GetMenus", "GetBtnResources"]),
        linkTo(extras) {
          if (!extras) return
          if (!extras.param) return
          // console.log('---------------------------------------------------------------onOpen extras.param', extras.param)
          if (extras.param == 'todo') {
            this.togo('/application/matters',{ key:2 })
          } else if (extras.param == 'toRead') {
            this.togo('/application/messages',{ key:1 })
          }
        },
        swipeHandler(e){
            if(this.forbidFinger === -1){
                if(e.direction === 'Left'){
                    this.slideLeft()
                }else if(e.direction === 'Right'){
                    this.slideRight()
                }
            }
        },
        /**
         * 触摸向左滑动
         * 当前页不在切换的路径数组中时，切换到上一页
         * 当前页存在footer切换路径数组中时，切换到footer上一页
         * 当前页存在list切换路径数组中时，切换到list上一页
         **/
        slideLeft() {
            // if(this.tabbarActive === -1 && this.tabListActive === -1){
            //     this.$router.go(-1)
            // }else
			if(this.tabbarActive !== -1){
                let pathlistNum = this.pathlist.length-1;
                if(this.tabbarActive === pathlistNum){
                    this.tabbarActive = 0
                }else if(-1<this.tabbarActive < pathlistNum){
                    this.tabbarActive = this.tabbarActive + 1
                }
            }else if(this.tabListActive !== -1){
                let tablistNum = this.tablist.length-1;
                if(this.tabListActive === tablistNum){
                    this.tabListActive = 0
                }else if(-1<this.tabListActive < tablistNum){
                    this.tabListActive = this.tabListActive + 1
                }
            }
        },
        /**
         * 触摸向右滑动
         * 当前页不在切换的路径数组中时，切换到上一页
         * 当前页存在footer切换路径数组中时，切换到footer下一页
         * 当前页存在list切换路径数组中时，切换到list下一页
         **/
        slideRight() {
            // if(this.tabbarActive === -1 && this.tabListActive === -1){
            //     this.$router.go(-1)
            // }else
			if(this.tabbarActive !== -1) {
                let pathlistNum = this.pathlist.length-1
                if(this.tabbarActive === 0){
                    this.tabbarActive = pathlistNum
                }else if(0 < this.tabbarActive < pathlistNum){
                    this.tabbarActive = this.tabbarActive - 1
                }
            }else if(this.tabListActive !== -1){
                let tablistNum = this.tablist.length-1;
                if(this.tabListActive === 0){
                    this.tabListActive = tablistNum
                }else if(0 < this.tabListActive < tablistNum){
                    this.tabListActive = this.tabListActive - 1
                }
            }
        },
        /**
         * 获取需要触摸切换的列表数组
         * @param val
         */
        tablistFun(val){
            this.tablist=val
        },
        /**
         * 判断path存在切换path数组中
         * @param path
         */
        pathchange(path) {
            let index;
            // if(path == '/mapdetails') {
            //     index = 2;
            //     this.tabbarActive=index;
            // }else
			if(this.pathlist.indexOf(path)>-1) {
                index = this.pathlist.indexOf(path);
                this.$store.state.navindex = index;
            }else{
                index = -1
			}
            this.tabbarActive=index;
            this.forbidFinger = this.forbidFingerList.indexOf(path);
            if(this.tabPageList.indexOf(path) > -1){
                this.tabListActive = 0;
            }else {
                this.tabListActive=-1;
            }
        },
		/**
		 * 键盘引起窗口的高度发生变化
		 **/
		handleHeight(){
            const originalHeight=document.documentElement.clientHeight ||document.body.clientHeight;
            window.onresize = ()=>{
                return(()=>{
                    //键盘弹起与隐藏都会引起窗口的高度发生变化
                    const resizeHeight=document.documentElement.clientHeight || document.body.clientHeight;
                    // window.plus.nativeUI.alert("进入到判断页面高度, 页面初始高度========="+originalHeight);
                    // window.plus.nativeUI.alert("软键盘弹起高度========="+resizeHeight);
                    if(resizeHeight-0<originalHeight-0){
                        //当软键盘弹起，在此处操作
                        // window.plus.nativeUI.alert("进入到软键盘弹起=========");
                        document.querySelector('body').setAttribute('style', 'height:'+originalHeight+'px;');
                        this.scrollerHeight=resizeHeight;
                    }else{
                        //当软键盘收起，在此处操作
                        // window.plus.nativeUI.alert("进入到软键盘收起=========");
                        document.querySelector('body').setAttribute('style', 'height:100%;');
                        this.scrollerHeight="100%";
                    }
                })()

            }
		},
    },
    watch:{
    },
    mounted() {
        this.pathchange(this.$route.path);
        // this.GetBtnResources();
        // this.GetMenus();

        this.handleHeight();
    },
}
</script>
